import { OTHER_INFO_FORM_FIELDS } from 'texts/otherInfoForm'

export const OTHER_INFO_INITIAL_VALUES = {
  [OTHER_INFO_FORM_FIELDS.API_TYPE.ID]: '',
}

export const OTHER_INFO_API_TYPE_ITEMS = [
  {
    value: 'Renteon',
    label: 'Renteon',
  },
  { value: 'CarOn', label: 'CarOn' },
  { value: 'CarPro', label: 'CarPro' },
  { value: 'CarRentalGateway', label: 'CarRentalGateway' },
  { value: 'Fleetrez', label: 'Fleetrez' },
  { value: 'HQ', label: 'HQ' },
  { value: 'Jimpisoft', label: 'Jimpisoft' },
  { value: 'JoyRent', label: 'JoyRent' },
  { value: 'KarveNew', label: 'KarveNew' },
  { value: 'RentalCarManager', label: 'RentalCarManager' },
  { value: 'RenthubSoftware', label: 'Renthub Software' },
  { value: 'Rently', label: 'Rently' },
  { value: 'RezRevolution', label: 'RezRevolution' },
  { value: 'Sofiac', label: 'Sofiac' },
  { value: 'SoRent', label: 'SoRent' },
  { value: 'Thermeon', label: 'Thermeon' },
  { value: 'Turev', label: 'Turev' },
  { value: 'WishCarRental', label: 'WishCarRental' },
  { value: 'CarFleet', label: 'CarFleet' },
  {
    value: 'Wheelsys',
    label: 'Wheelsys (Wheels)',
  },
  {
    value: 'Ratechain',
    label: 'Ratechain',
  },
  {
    value: 'TSD',
    label: 'TSD',
  },
  {
    value: 'DontHave',
    label: 'Don’t have',
  },
  {
    value: 'Other',
    label: 'Other type',
  },
]
